import { User } from '@auth0/auth0-react';
import { useMemo } from 'react';
import { CustomUserFields } from './useAuthUser';
import {
  onboardingRoutes,
  processorOnboardingRoutes,
  merchantRoutes,
  errorRoutes,
  processorRoutes,
  adminRoutes,
  agentRoutes,
  managerRoutes,
} from '../configs/routesConfig';

interface IProps {
  user: (User & CustomUserFields) | undefined;
}

const useUserRoles = ({ user }: IProps) => {
  const currentRoutes = useMemo(() => {
    if (user?.role === 'admin') {
      return adminRoutes;
    }
    if (user?.role === 'manager') {
      return managerRoutes;
    }
    if (user?.role === 'agent') {
      return agentRoutes;
    }
    if (user?.role === 'processor' && !user?.onboarding) {
      return processorOnboardingRoutes;
    }
    if (!user?.role || !user?.onboarding) {
      return onboardingRoutes;
    }
    if (user?.role === 'merchant') {
      return merchantRoutes;
    }
    if (user?.role === 'processor') {
      return processorRoutes;
    }

    return errorRoutes;
  }, [user]);

  return currentRoutes;
};

export default useUserRoles;
